import { useMemo } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import {
  useGoalsOptionsApi,
  type GoalOptionType,
} from '../api/queries/useGoalsOptionsApi.js';

export type GoalOptionGroupsType = {
  key: string;
  label: string;
  options: GoalOptionType[];
}[];

export const useGoalOptionGroups = (): GoalOptionGroupsType => {
  const { t } = useTranslation('@myn/planning_v2');
  const { data } = useGoalsOptionsApi();

  return useMemo(() => {
    if (!data) {
      return [];
    }

    return [
      { key: 'overall', label: t('Generic'), options: data.overall },
      {
        key: 'dataImportHub',
        label: t('Custom metrics'),
        options: data.dataImportHub,
      },
      {
        key: 'adServer',
        label: t('Adserver'),
        options: data.adServer,
      },
      {
        key: 'googleAnalytics',
        label: t('Google Analytics'),
        options: data.googleAnalytics,
      },
      {
        key: 'platform',
        label: t('Platform'),
        options: data.platform,
      },
    ].filter((group) => group.options.length > 0);
  }, [data, t]);
};
